import { useState } from 'react';
import { faqs } from '@/mocks/homeData';

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,360px)_1fr] gap-8 lg:gap-14">
          <div>
            <p className="flex items-center gap-2 text-primary-600 text-xs md:text-sm font-label font-medium tracking-wide">
              <i className="ri-question-answer-line" />
              常见问答
            </p>
            <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl leading-snug">
              关于榜单与合集，你可能想问
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              关于热门榜、必看清单、高能盘点与爆款合集的常见问题，都整理在这里。
            </p>
          </div>

          <div className="border-t border-background-300">
            {faqs.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id} className="border-b border-background-300">
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : item.id)}
                    className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
                  >
                    <h4 className="font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug group-hover:text-primary-600 transition-colors">
                      {item.q}
                    </h4>
                    <span
                      className={`mt-0.5 w-7 h-7 shrink-0 flex items-center justify-center rounded-full border transition-colors ${
                        open
                          ? 'bg-primary-500 border-primary-500 text-background-50'
                          : 'border-background-400 text-foreground-600'
                      }`}
                    >
                      <i className={open ? 'ri-subtract-line' : 'ri-add-line'} />
                    </span>
                  </button>
                  {open && (
                    <p className="pb-5 pr-10 text-foreground-600 text-sm leading-relaxed">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}